import { appendToast, appendToastMessage } from '../features/toast.js';

export function initializeGlobalFetchWrapper() {
    const originalFetch = window.fetch;

    window.fetch = async (resource, options = {}) => {
        const headers = new Headers(options.headers);
        if (!headers.has('X-Fetch-Mode')) {
            headers.set('X-Fetch-Mode', 'normal');
        }
        const newOptions = { ...options, headers: headers };

        const response = await originalFetch(resource, newOptions);
        const contentType = response.headers.get('Content-Type');
        if (contentType && contentType.includes('application/json')) {
            try {
                const json = await response.clone().json();
                if ('toast' in json) {
                    appendToast(json.toast);
                } else if ('code' in json && 'message' in json) {
                    const errorMessage = json.message || 'An unexpected error occurred.';
                    appendToastMessage('error', `${errorMessage} (code: ${json.code} )`);
                }
            } catch {
                return response;
            }
        }

        return response;
    };
}
